import { lazy } from 'react';

/** Открывает форму паспортных данных исполнителя */
export const ExecutorPassportPageAsync = lazy(() => import('./ExecutorPassport/ExecutorPassportPage'));
